/** @enum {string} */
export enum PageEventName {
  PAGE_CLEAR = "pageclear",
}

export enum PageZoomEnum {
  ZOOM_DOWN = 1,
  ZOOM_UP = 2,
}
